import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaProgressCircle from './VaProgressCircle.vue'

export const VaProgressCircle = withConfigTransport(_VaProgressCircle)
